import moment from 'moment';
import { SMS_ALLOWED_CHARS_REGEX } from './sms.constants';

export const containsSupportedCharacters = (messageContent) => {
    return messageContent ? SMS_ALLOWED_CHARS_REGEX.test(messageContent) : true;
};

export const getResubmissionDaysRemaining = (rejectionDate, daysToResubmit = 7) => {
    if (!rejectionDate) {
        return 0;
    }

    const momentNow = moment();
    const momentRejected = moment(rejectionDate);
    const daysElapsed = Math.ceil(moment.duration(momentNow.diff(momentRejected)).asDays());
    const result = daysToResubmit - daysElapsed;

    return typeof result === 'number' && result >= 0 ? result + 1 : 0;
};
